import React from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { FORM_URL, INTEREST_MAP } from "./courseData";

import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";


const DemoBookingForm = ({ initialLanguage = "", initialLevel = "" }) => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [language, setLanguage] = React.useState(initialLanguage);
  const [level, setLevel] = React.useState(initialLevel);
  const [timing, setTiming] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  React.useEffect(() => {
    if (initialLanguage) setLanguage(initialLanguage);
  }, [initialLanguage]);

  React.useEffect(() => {
    if (initialLevel) setLevel(initialLevel);
  }, [initialLevel]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name) return NotificationManager.error("Name is required");
    if (!email) return NotificationManager.error("Email is required");
    if (!phone || !isValidPhoneNumber(phone)) {
      return NotificationManager.error("Please enter a valid phone number");
    }
    if (!language) return NotificationManager.error("Please select a language");
    if (!level) return NotificationManager.error("Please select a level");
    if (!timing) return NotificationManager.error("Please select a timing");

    setLoading(true);

    const interest = INTEREST_MAP[language] || `I want to Learn ${language}`;
    const message = [
      "Demo Class Booking Request",
      `Level: ${level}`,
      `Preferred Timing: ${timing}`,
      "Source: Demo Page",
    ].join(" | ");

    try {
      const formData = new FormData();
      formData.append("entry.1102309209", name);
      formData.append("emailAddress", email);
      formData.append("entry.774180726", phone);
      formData.append("entry.1793295208", interest);
      formData.append("entry.371784238", message);

      await fetch(FORM_URL, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      NotificationManager.success("Demo class booked successfully!");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lead_form_submit",
        course_interest: interest,
        page_path: window.location.pathname,
        form_type: "demo_booking_landing",
      });

      setSubmitted(true);
    } catch (error) {
      NotificationManager.error("Oops! Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="contact__card ll-thank-you">
        <div className="ll-thank-you__icon">✓</div>
        <h5>Demo Class Booked!</h5>
        <p>
          Thank you for your interest in Koderbox. Our team will call you within
          24 hours to confirm your free demo class slot.
        </p>
        <a href="tel:9990484089" className="btn btn-primary">
          Call Us: +919990484089
        </a>
      </div>
    );
  }

  return (
    <div className="contact__card">
      <form onSubmit={handleSubmit} className="contact__card--form">
        <h5>Book Your FREE Demo Class Today</h5>
        <p className="ll-form-subtext">Limited seats available. No payment required.</p>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          {/* <input
            className="form-control"
            type="tel"
            minLength={10}
            maxLength={10}
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          /> */}
          <PhoneInput
              className="form-control"
              international
              defaultCountry="IN"
              value={phone}
              onChange={(value) => {
                if (!value || value.length <= 15) {
                  setPhone(value);
                }
              }}
              placeholder="Enter phone number"
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            required
          >
            <option value="">Select Language</option>
            <option value="Japanese">Japanese</option>
            <option value="German">German</option>
            <option value="French">French</option>
            <option value="Korean">Korean</option>
          </select>
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={level}
            onChange={(e) => setLevel(e.target.value)}
            required
          >
            <option value="">Select Level</option>
            <option value="Beginner">Beginner</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Advanced">Advanced</option>
          </select>
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={timing}
            onChange={(e) => setTiming(e.target.value)}
            required
          >
            <option value="">Preferred Timing</option>
            <option value="Morning">Morning</option>
            <option value="Afternoon">Afternoon</option>
            <option value="Evening">Evening</option>
          </select>
        </div>

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Booking..." : "Book My Free Demo →"}
        </button>
      </form>

      <NotificationContainer />
    </div>
  );
};

export default DemoBookingForm;
